import { useTranslation } from "react-i18next";

const cardinalityClassMap = {
    '1-1': 'O2O',
    '1-*': 'O2M',
    '*-*': 'M2M',
}

function RelationCardinality({
    fromEntityName, cardinality, toEntityName
}) {
    return (
        <div className="selected-cardinality1 w-100">
			<div className="m-0 row no-gutters" style={{ height: 40 }}>
				<div className="col-5 p-0">
					<div className="p-2 text-center rounded text-truncate btn-secondary-shape" title={fromEntityName}>
						{ fromEntityName }
					</div>
				</div>
				<div
                    className={`col-2 p-0 d-flex align-items-center justify-content-center ${cardinalityClassMap[cardinality]}`}
                ></div>
				<div className="col-5 p-0">
					<div className="p-2 text-center rounded text-truncate btn-secondary-shape" title={toEntityName}>
						{ toEntityName }
					</div>
				</div>
			</div>
			<RelationCardinalityDescription
				fromEntityName={fromEntityName}
				toEntityName={toEntityName}
				cardinality={cardinality} />
		</div>
    )
}

function RelationCardinalityDescription({ fromEntityName, toEntityName, cardinality }) {

	const { t } = useTranslation("linked_entity/recommended_relation_card", { useSuspense: false });

	return (
		<>
			<div className="mt-2 mb-2 d-block text-center">
				&nbsp;{t("message.one", { ns: "linked_entity/recommended_relation_card" })}
				<b className="cardinality-label" title={fromEntityName}>
					&nbsp;
					{ fromEntityName }
				</b>
				&nbsp;{ t("message.can_be_linked_to", { ns: "linked_entity/recommended_relation_card" }) }
				&nbsp;
				{
					cardinality === '1-1' ?
					t("message.one", { ns: "linked_entity/recommended_relation_card" }).toLowerCase()
					:
					t("message.many", { ns: "linked_entity/recommended_relation_card" }).toLowerCase()
				}
				<b className="cardinality-label" title={toEntityName}>
					&nbsp;
					{ toEntityName }
				</b>
			</div>
			<div className="mb-2 d-block text-center">
				&nbsp;{t("message.one", { ns: "linked_entity/recommended_relation_card" })}
				<b className="cardinality-label" title={toEntityName}>
					&nbsp;
					{ toEntityName }
				</b>
				&nbsp;{ t("message.can_be_linked_to", { ns: "linked_entity/recommended_relation_card" }) }
				&nbsp;
				{
					cardinality === '*-*' ?
					t("message.many", { ns: "linked_entity/recommended_relation_card" }).toLowerCase()
					:
					t("message.one", { ns: "linked_entity/recommended_relation_card" }).toLowerCase()
				}
				<b className="cardinality-label" title={fromEntityName}>
					&nbsp;
					{ fromEntityName }
				</b>
			</div>
		</>
	)
}

export default RelationCardinality;